import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Discussion from 'flarum/common/models/Discussion';
import User from 'flarum/common/models/User';
import Badge from 'flarum/common/components/Badge';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import Button from 'flarum/common/components/Button';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import username from 'flarum/common/helpers/username';
import AlertUtil from 'flarum/forum/dianLiang/AlertUtil';
import PostControls from 'flarum/forum/utils/PostControls';

export default function addIgnoredUserBadge() {
  extend(DiscussionControls, 'destructiveControls', function (items, discussion) {
    if (app.session.user && app.session.user != discussion.user()  && discussion.user().canBeIgnored()) {
      items.add(
        'ignore',
        <Button icon="img-more-lh" onclick={this.ignoreAction.bind(discussion)} ontouchend={(e)=>{
          e.preventDefault()
          this.ignoreAction.bind(discussion)()}}>
          {app.translator.trans(`dl-blackList.forum.${!discussion.user().ignored() ? 'ignore' : 'not_ignore'}_button`)}
        </Button>
      );
    }
  });

  extend(PostControls, 'destructiveControls', function (items, post) {
    let discussion = post.discussion();
    if (app.session.user && app.session.user != post.user() && post.user().canBeIgnored()) {
      items.add(
        'ignore',
        <Button icon="img-more-lh" onclick={DiscussionControls.ignoreAction.bind(post)} ontouchend={(e)=>{
          e.preventDefault()
          DiscussionControls.ignoreAction.bind(post)()}}>
          {app.translator.trans(`dl-blackList.forum.${!post.user().ignored() ? 'ignore' : 'not_ignore'}_button`)}
        </Button>
      );
    }
  });

  DiscussionControls.ignoreAction = function () {
    let ignored = !this.user().ignored();
    let isSure = false;
    if (ignored) {
      if (confirm(app.translator.trans('dl-blackList.forum.ignore_confirm', { username: this.user().nickname() }))) {
        isSure = true;
      }
    }else {
      if (confirm(app.translator.trans('dl-blackList.forum.not_ignore_confirm', { username: this.user().nickname() }))) {
        isSure = true;
      }
    }
    if (isSure) {
      this.user().save({ ignored: ignored }).then(() => {
        if (app.current.matches(DiscussionPage)) {
          app.current.get('stream').update();
        }
        AlertUtil.onSuccess(app, app.translator.trans(`dl-index.forum.permissions.success_${!ignored ? 'not_ignore_label' : 'ignore_label'}`))
        m.redraw();
      });
    }
  };

  extend(Discussion.prototype, 'badges', function (badges) {
    let badge;

    if (this.user() && this.user().ignored()) {
      badge = Badge.component({
        label: app.translator.trans('fof-ignore-users.forum.badge.discussion_label'),
        icon: 'fas fa-user-slash',
        // type: 'ignored',
      });
    }

    if (badge) {
      badges.add('user-discussion-ignored', badge);
    }
  });

  extend(User.prototype, 'badges', function (badges) {
    let badge;

    if (this.ignored()) {
      badge = Badge.component({
        label: app.translator.trans('fof-ignore-users.forum.badge.user_label'),
        icon: 'fas fa-user-slash',
        // type: 'ignored',
      });
    }

    if (badge) {
      badges.add('user-ignored', badge);
    }
  });
}
